import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { commitMutation, graphql } from 'react-relay';
import { Grid } from 'semantic-ui-react';
import styles from '../Event.scss';
import Formsy from 'formsy-react';
import { TextArea } from '../../Elements';
import { Analytics, GlobalNotifications, Intent } from '../../Modules';
import ReferralSource from './ReferralSource';
import Contacts from './Contacts';
import Schedule from './ScheduleContainer';

export default class EventSummary extends React.Component {
  static propTypes = {
    node: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    children: PropTypes.node
  };

  constructor(props) {
    super(props);
    this.updateEventNotes = this.updateEventNotes.bind(this);
    this.notesChangeHandler = this.notesChangeHandler.bind(this);
    this.refetchEvent = this.refetchEvent.bind(this);
    this.referralChangeHandler = this.referralChangeHandler.bind(this);

    this.state = {
      event: _.cloneDeep(this.props.node),
      editingNewContact: false
    };
  }

  refetchEvent() {
    this.props.relay.refetch(
      (fragmentVariables) => fragmentVariables, null
    );
  }

  referralChangeHandler(e, data) {
    const onError = () => {
      GlobalNotifications.show({
        message: 'Unable to update referral source',
        intent: Intent.DANGER
      });
    };
    const onCompleted = () => {
      GlobalNotifications.show({
        message: 'Successfully updated referral source',
        intent: Intent.SUCCESS
      });
      Analytics.trackEvent('updated-referral-source');
    };

    const mutation = graphql`
      mutation EventSummaryComponent_Referral_UpdateUserEventMutation(
        $input: UpdateUserEventInput!
      ) {
        updateUserEvent(input: $input) {
          user_event {
            id
            referral_source
            notes
          }
        }
      }
    `;
    const id = this.props.node.user_event.id;
    // eslint-disable-next-line camelcase
    const referral_source = data.value;
    const optimisticResponse = {
      updateUserEvent: { user_event: { id, referral_source } }
    };
    const environment = this.props.relay.environment;

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          id,
          referral_source
        }
      },
      optimisticResponse,
      onCompleted,
      onError
    });
  }

  notesChangeHandler(e) {
    const obj = _.cloneDeep(this.state);
    obj.event.user_event.notes = e.target.value;
    this.setState({ ...obj });
  }

  updateEventNotes() {
    const onError = () => {
      GlobalNotifications.show({
        message: 'Unable to update event notes',
        intent: Intent.DANGER
      });
    };
    const onCompleted = () => {
      GlobalNotifications.show({
        message: 'Successfully updated event notes',
        intent: Intent.SUCCESS
      });
      Analytics.trackEvent('updated-event-notes');
    };

    // Update event if values have changed
    if (this.props.node.user_event.notes !== this.state.event.user_event.notes) {
      const mutation = graphql`
        mutation EventSummaryComponent_Notes_UpdateUserEventMutation(
          $input: UpdateUserEventInput!
        ) {
          updateUserEvent(input: $input) {
            user_event {
              id
              referral_source
              notes
            }
          }
        }
      `;
      // eslint-disable-next-line camelcase
      const { id, notes } = this.state.event.user_event;
      const optimisticResponse = {
        updateUserEvent: { user_event: { id, notes } }
      };
      const environment = this.props.relay.environment;

      commitMutation(environment, {
        mutation,
        variables: {
          input: {
            id,
            notes
          }
        },
        optimisticResponse,
        onCompleted,
        onError
      });
    }
  }

  render() {
    const event = this.props.node;
    return (
      <div>
        {this.props.children}
        <Grid stackable padded>
          <Grid.Row columns={3}>
            <Grid.Column>
              <h3>Notes</h3>
              <Formsy.Form className={`ui form field ${styles.notepad}`}>
                <TextArea
                  name='notes'
                  rows={12}
                  onBlur={this.updateEventNotes}
                  onChange={this.notesChangeHandler}
                  value={this.state.event.user_event.notes || ''}
                />
                <h3>Referral Source</h3>
                <ReferralSource
                  onChange={this.referralChangeHandler}
                  label=''
                  value={this.props.node.user_event.referral_source}
                  pastReferralSources={
                    this.props.viewer.past_referral_sources
                  }
                />
              </Formsy.Form>
            </Grid.Column>
            <Grid.Column>
              <h3>Schedule</h3>
              <Schedule viewer={this.props.viewer} node={this.props.node.user_event} />
            </Grid.Column>
            <Grid.Column>
              <h3>Contacts</h3>
              <Contacts
                event={event}
                relay={this.props.relay}
                viewer={this.props.viewer}
                refetchEvent={this.refetchEvent}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/EventSummaryComponent.js